import ArrowUpIcon from '@base/components/src/Icon/KeyboardArrowUp';
import QuestionMarkIcon from '@base/components/src/Icon/QuestionMarkIcon';
import Popover from '@base/components/src/Popover';
import { ProductFeeProps } from './types';
import clsx from 'clsx';

import styles from './ProductFee.module.css';

const ProductFee = ({ data, className }: Readonly<ProductFeeProps>) => (
  <div className={clsx(styles.productFeeBox, className)}>
    <div className="mr-2">
      <span>{data.name}</span>
    </div>
    <Popover
      data-testid="product-fee"
      contentClassName={clsx(styles.productTooltipPaper, styles.tooltipContentWrapper)}
      containerClassName={styles.tooltipContainer}
      showShadow={false}
      anchorComponent={() => <QuestionMarkIcon className={styles.questionMark} />}
      popoverContent={() => (
        <div className={styles.tooltipContent}>
          <span className={styles.arrowUp}>
            <ArrowUpIcon className={`${styles.arrowUp} ${styles.arrowUpColor}`} />
          </span>
          <span>
            <div className={styles.tooltipContentMessage}>{data.message}</div>
          </span>
        </div>
      )}
    />
  </div>
);

export default ProductFee;
